import React from "react";
import { Check, X } from "lucide-react";

export function optionClass({ oi, chosen, correctIndex, graded }) {
  if (graded) {
    if (oi === correctIndex) return "border-lime-400/50 bg-lime-500/10 text-lime-200";
    if (oi === chosen) return "border-red-400/50 bg-red-500/10 text-red-200";
    return "border-white/5 text-slate-400";
  }
  if (chosen === oi) return "border-cyan-400/60 bg-cyan-500/10 text-cyan-100";
  return "border-white/10 hover:border-cyan-400/40 hover:bg-cyan-500/5 text-slate-200";
}

export function QuizOptions({ options, chosen, correctIndex, graded, onChoose, testId, compact = false }) {
  return (
    <div className="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-2">
      {options.map((opt, oi) => (
        <button
          key={`${oi}-${opt}`}
          disabled={graded}
          onClick={() => onChoose(oi)}
          data-testid={testId(oi)}
          className={`flex items-center justify-between rounded-md border text-left transition-colors ${compact ? "px-3 py-2 text-xs sm:text-sm" : "px-4 py-3 text-sm"} ${optionClass({ oi, chosen, correctIndex, graded })}`}
        >
          <span>{opt}</span>
          {graded && oi === correctIndex && <Check size={14} />}
          {graded && oi === chosen && oi !== correctIndex && <X size={14} />}
        </button>
      ))}
    </div>
  );
}
